import { render, staticRenderFns } from "./HeaderPage.vue?vue&type=template&id=7e41362e"
import script from "./HeaderPage.vue?vue&type=script&lang=js"
export * from "./HeaderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e41362e')) {
      api.createRecord('7e41362e', component.options)
    } else {
      api.reload('7e41362e', component.options)
    }
    module.hot.accept("./HeaderPage.vue?vue&type=template&id=7e41362e", function () {
      api.rerender('7e41362e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/global/v2/HeaderPage.vue"
export default component.exports